<template>
    <td>
        <template v-if="!data.auto_app_goals">
            <input type="number" class="form-control" style="width: 60px; display: inline-block" v-model="data.multicarrier.app_goal"></input>
        </template>
        <template v-if="data.auto_app_goals">
            <input class="form-control" style="width: 60px; display: inline-block" v-model="data.auto_app_goal_mc_min" v-bind:disabled="!['mc+direct', 'mc+driverboost', 'mc+ja', 'mc+driverboost+jb'].includes(data.auto_lead_type)"></input>
            -
            <input class="form-control" style="width: 60px; display: inline-block" v-model="data.auto_app_goal_mc_max" v-bind:disabled="!['mc+direct', 'mc+driverboost', 'mc+ja', 'mc+driverboost+jb'].includes(data.auto_lead_type)"></input>
        </template>
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>